var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBlade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-blade",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#5e5e5d}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-base",
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-2",
    d: "M27.35 12.52a.47.47 0 0 1 .14.33v20.41a1.79 1.79 0 0 1-1.8 1.8H14.31a1.8 1.8 0 0 1-1.8-1.79V12.86a.48.48 0 0 1 .14-.34L20 5.17zm-7.68-8.34L12 11.86a1.41 1.41 0 0 0-.41 1v20.41A2.74 2.74 0 0 0 14.31 36H25.7a2.74 2.74 0 0 0 2.73-2.74V12.85a1.41 1.41 0 0 0-.41-1l-7.69-7.67a.45.45 0 0 0-.66 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-2",
    d: "M22.83 17.39v17.88h-5.66V17.39L20 14.56zm2.93 18.12V17a2 2 0 0 0-.58-1.39L21 11.45a1.47 1.47 0 0 0-2.07 0l-4.11 4.15a2 2 0 0 0-.58 1.4v18.51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBlade);
export default __webpack_public_path__ + "static/media/icn-blade.9de419fa1c66b050b7716b823fe1a37e.svg";
export { ForwardRef as ReactComponent };